/** Mismo criterio que AtencionInfoMobile: números argentinos vía tel:+54 y WhatsApp vía wa.me */
export const getTelUrl = (number) => {
  if (!number) return "#";
  const digits = String(number).replace(/\D/g, "");
  if (!digits) return "#";
  const phone = digits.startsWith("0") ? "9" + digits.slice(1) : digits;
  return `tel:+54${phone}`;
};

export const getWhatsAppUrl = (number) => {
  if (!number) return "https://wa.me/541130159749";
  const digits = String(number).replace(/\D/g, "");
  if (!digits) return "https://wa.me/541130159749";
  const phone = digits.startsWith("0") ? "9" + digits.slice(1) : digits;
  return `https://wa.me/54${phone}`;
};
